import React, { createContext, useContext } from 'react';
import { WebTableContextValue } from '@experiences/components/table/types';

const TableContext = createContext<WebTableContextValue | null>(null);

export const TableProvider: React.FC<{
  children: React.ReactNode;
  value: WebTableContextValue;
}> = ({ children, value }) => {
  return (
    <TableContext.Provider value={value}>{children}</TableContext.Provider>
  );
};

export const useTableContext = (): WebTableContextValue => {
  const context = useContext(TableContext);
  if (!context) {
    throw new Error('useTableContext must be used within a TableProvider');
  }
  return context;
};
